/* eslint-disable */
import * as React from "react";

import { ReportRenderer } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { CalendarControl2 } from "../controls/CalendarControl2";

import { useSubscription } from "./useSubscription";

export default function () {
  useSubscription();
  return (
    <>
      <ReportToolbarGroup>
        <CalendarControl2 />
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="chart-area-production-yield" />
          <ReportRenderer componentId="chart-area-production-yield2" />
        </ReportGrid>
      </div>
    </>
  );
}
